import { Store } from '@ngrx/store';
import { Collection, Seq } from 'immutable';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { AppState } from 'src/store/appstate';

export function selectViewModel<TIn, TOut>(
  store: Store<AppState>,
  mapFn: (state: AppState) => TIn | undefined,
  createViewModelFn: (v: TIn) => TOut,
) {
  return store.select(mapFn).pipe(
    distinctUntilChanged(),
    map((v) => (v != null ? createViewModelFn(v) : undefined)),
  );
}

export function selectManyViewModels<TIn, TOut>(
  store: Store<AppState>,
  mapFn: (state: AppState) => Collection<any, TIn>,
  createViewModelFn: (v: TIn) => TOut,
) {
  return store.select(mapFn).pipe(
    distinctUntilChanged(),
    map((v) => (v != null ? v.map(createViewModelFn).valueSeq() : Seq.Indexed<TOut>())),
  );
}
